import DojoMetrics from "@classdojo/dojo-metrics";
import LogClientBackend from "@classdojo/dojo-metrics/lib/backends/logClient";

export const metrics = new DojoMetrics({
  app: "marketplace",
  backends: [LogClientBackend()],
  env: "{{DEPLOY_GROUP}}",
});
